



















import { defineComponent } from '@vue/composition-api'
import Branding from './Branding.vue'
import NavMenu from './NavMenu.vue'
import ProfileMenu from './ProfileMenu.vue'
import ClientSelector from '@/contexts/client-admin/ClientSelector.vue'
import ClientLogo from '@/contexts/client-admin/ClientLogo.vue'
import TimeSession from './TimeSession.vue'

export default defineComponent({
  components: {
    branding: Branding,
    'nav-menu': NavMenu,
    'profile-menu': ProfileMenu,
    'client-selector': ClientSelector,
    'client-logo': ClientLogo,
    'time-session': TimeSession
  }
})
